``<template>
    <Transition name="fade-in">
        <div
            v-if="show"
            v-bind:class="messageClass"
            v-on:click="hide"
        >
            {{ message }}
        </div>
    </Transition>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent, onMounted, ref } from 'vue';

    export default defineComponent({
        name: 'Message',
        emits: ['clearMessage'],
        props: {
            duration: {
                type: Number,
                default: 5000,
            },
            status: {
                type: String as PropType<'success' | 'error'>,
                default: 'success',
            },
            message: {
                type: String,
                required: true,
            },
        },
        setup(props, { emit }) {
            const show = ref(true);

            const messageClass = computed(() => [
                'message',
                `status-${props.status}`,
            ]);

            const hide = () => {
                show.value = false;
                emit('clearMessage');
            };

            onMounted(() => {
                setTimeout(() => hide(), props.duration);
            });

            return {
                show,
                messageClass,
                hide,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/message";
</style>
